import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { IS_LOADING } from "lib/graphql/return-is-loading-on-each-request"
import Iconify from "minimals-template/components/Iconify"
import { linkButtonSx, linkedButtonSx, unlinkButtonPositionSx } from "./component-link-button-styles"
import { preventPropagation } from "lib/prevent"
import { Time } from "routes/schedule/tasks/time"
import { HighlightBox } from "lib/@components/highlightBox"
import { DurationLabel } from "./component-ref-duration-label"

const FIELD = "duration"

export function DurationControl() {
    const { componentRef, linkedFields, onEnableField, onDisableField, editMode, componentTask } = useBoundContext()
    const isLinked = !!componentRef && linkedFields?.[FIELD]
    const isLoading = componentRef && componentTask === IS_LOADING

    if (!isLinked) {
        const canLink = !!componentRef && componentHasDuration(componentTask)

        return (
            <>
                <Time />
                {editMode && canLink && (
                    <Box sx={unlinkButtonPositionSx}>
                        <Tooltip title="Link duration from component">
                            <IconButton
                                size="small"
                                onClick={preventPropagation(handleEnable)}
                                className="component-link-btn"
                                sx={linkButtonSx}
                                aria-label="Link duration"
                            >
                                <Iconify icon="mdi:puzzle-plus-outline" sx={{ width: 14, height: 14 }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}
            </>
        )
    }

    if (isLoading) {
        return (
            <Box display="inline-flex" alignItems="center" sx={{ width: 24, height: 24 }}>
                <CircularProgress size={16} />
            </Box>
        )
    }

    if (!componentTask) return <Time />

    return (
        <HighlightBox path="minutes" display="inline-flex" alignItems="center">
            <Tooltip title={`Inherited from: ${componentTask.heading ?? componentRef}`}>
                <Box display="inline-flex" alignItems="center" gap={0.5} sx={{ opacity: editMode ? 0.6 : 1 }}>
                    <DurationLabel minutes={componentTask.minutes} />
                    {editMode && (
                        <IconButton
                            size="small"
                            onClick={preventPropagation(handleDisable)}
                            sx={linkedButtonSx}
                            aria-label="Unlink duration"
                        >
                            <Iconify icon="mdi:link-variant" sx={{ width: 14, height: 14 }} />
                        </IconButton>
                    )}
                </Box>
            </Tooltip>
        </HighlightBox>
    )

    function handleEnable() {
        onEnableField?.(FIELD)
    }

    function handleDisable() {
        onDisableField?.(FIELD)
    }
}

function componentHasDuration(task) {
    if (!task || task === IS_LOADING) return false
    return typeof task.minutes === "number" && !Number.isNaN(task.minutes)
}
